import { render } from "./404NotFound.vue?vue&type=template&id=3a2722b5&scoped=true"
import script from "./404NotFound.vue?vue&type=script&lang=js"
export * from "./404NotFound.vue?vue&type=script&lang=js"

import "./404NotFound.vue?vue&type=style&index=0&id=3a2722b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2722b5"]])

export default __exports__